import { render } from "./ZUpload.vue?vue&type=template&id=db47e0f0&ts=true"
import script from "./ZUpload.vue?vue&type=script&lang=ts"
export * from "./ZUpload.vue?vue&type=script&lang=ts"

import "./ZUpload.vue?vue&type=style&index=0&id=db47e0f0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__